<template>
  <footer class="main-footer" :class="darkMode ? 'dark-mode text-white' : ''">
    <strong>Copyright &copy; 2026.</strong>
    Todos los derechos reservados
    <div class="float-right d-none d-sm-inline-block"><b>Version</b> 1.1.0</div>
  </footer>
</template>
<script>
export default {
  name: "ContentWrapper",
  computed: {
    darkMode() {
      return this.$store.getters.getDarkMode;
    },
  },
};
</script>